// extracted by mini-css-extract-plugin
export var $animation_name = "AddToCartButton-module--$animation_name--f5156";
export var AddToCartButton = "AddToCartButton-module--AddToCartButton--f5890";
export var AddToCartButton___added = "AddToCartButton-module--AddToCartButton___added--15112";